/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_2_TitleInputs */

const es_home_features_item_2_title = /** @type {(inputs: Home_Features_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectores Múltiples`)
};

const en_home_features_item_2_title = /** @type {(inputs: Home_Features_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple Connectors`)
};

/**
* | output |
* | --- |
* | "Multiple Connectors" |
*
* @param {Home_Features_Item_2_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_2_title = /** @type {((inputs?: Home_Features_Item_2_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_2_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_2_title(inputs)
	return en_home_features_item_2_title(inputs)
});
export { home_features_item_2_title as "home.features.item_2_title" }